import { render, staticRenderFns } from "./EmailOTPVerification.vue?vue&type=template&id=b923c2a8&"
import script from "./EmailOTPVerification.vue?vue&type=script&lang=js&"
export * from "./EmailOTPVerification.vue?vue&type=script&lang=js&"
import style0 from "./EmailOTPVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports